module.exports = __webpack_public_path__ + "img/avatar.9ffa8d1d.jpg";